import React from "react";
import { Dialog, Button } from "components";
import { Link } from "react-router-dom";
import MuiDialogContent from '@material-ui/core/DialogContent';

import Label from "egov-ui-kit/utils/translationNode";
import "./index.scss";

const styles = {
  logoutContentStyle: { textAlign: "center", padding: "24px 20px" },
};

const LogoutDialog = ({ popupClose, popupOpen ,popupSet,pwdExpiryDateDDMMYYY}) => {
  return (
    <Dialog
      open={popupOpen}
      isClose={true}
      title={
        <Label label={"COMMON_HEADING_EXPIRE"} bold={true} color="rgba(0, 0, 0, 0.8700000047683716)" fontSize="20px" labelStyle={{ padding: "16px 0px 0px 24px" }} />
      }
      children={[
        <Label label={"password Expire Message"} bold={false} color="rgba(0, 0, 0, 0.8700000047683716)" fontSize="16px" labelStyle={{ padding: "16px 0px 16px 24px" }} />,
        <Label label={`Password Expire on: ${pwdExpiryDateDDMMYYY}`} bold={false} color="rgba(0, 0, 0, 0.8700000047683716)" fontSize="16px" labelStyle={{ padding: "16px 0px 16px 24px" }} />,
        <div className="col-xs-12" style={{ textAlign: "right" }} >
          {/* style={{ textAlign: "right",paddingBottom:"16px",width:"100%",display:"flex" }} */}
          <Button
           // label="OK"
            onClick={popupClose}
            className="logout-yes-button"
            label={<Label buttonLabel={true} label={"OK"} color="#FE7A51" />}
            backgroundColor={"#fff"}      
            style={{ boxShadow: "none" }}
            
          />
          <Button
           // label="OK"
            onClick={popupSet}
            className="logout-yes-button"
            label={<Label buttonLabel={true} label={"CORE_COMMON_CHANGE_PASSWORD"} color="#FE7A51" />}
            backgroundColor={"#fff"}      
            style={{ boxShadow: "none" }}
          
          />
          {/* <Link to="/user/change-password">
              <div style={{ marginTop: "24px", marginBottom: "24px" }}>
                <Label className="change-password-label-style" label={"CORE_COMMON_CHANGE_PASSWORD"} color="#f89a3f" />
              </div>
            </Link> */}
         {/* <Button
            label="Set Password"
            onClick={popupSet}
            labelStyle={{ letterSpacing: 0.7, padding: 0 }}
            buttonStyle={{ border: "1px solid #fe7a51" }}
            style={{ marginRight: 45, width: "36%" }}
          /> */}
        </div>

      ]
      
    
    }
      handleClose={popupClose}
      contentClassName={"logout-popup"}
      contentStyle={{ width: "90%" }}
     // isClose={true}
    />
  );
};

export default LogoutDialog;



// WEBPACK FOOTER //
// ./src/modules/employee/Inbox/components/PwdDialog/index.js